export default __webpack_public_path__ + "static/media/start-point.7cd1a3b6.svg";